export default function ({ store, redirect }) {
  if (!store.getters["user/isPortalUser"]) {
    return redirect('/')
  }
}
